import axios from 'axios';
import { makeApiUrl } from '@services/MarppleShop/shared/util';

/**
 * 상품이 심사 중 상태인지 판별하는 함수
 * true: 심사완료
 * false: 심사 중
 * @param store_id
 * @param store_product_id
 */
export const isCheckDesignApi = async (store_id: number, store_product_id: number) => {
  const { data } = await axios.get<boolean>(
    makeApiUrl('/@api/stores/:store_id/digital_products/:store_product_id/is_check_design', {
      store_id,
      store_product_id,
    }),
  );
  return data;
};
